var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHello(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 880.503,
    height: 522.591,
    viewBox: "0 0 880.503 522.591",
    xmlnxlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(-707.855 -327.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298-2742",
    "data-name": "Path 298",
    d: "M.982,1.458s.305,11.9-.916,13.125S14.717,51.822,32.116,35.95s3.968-22.282,3.968-22.282-6.41-11.9-6.1-13.125-28.387,0-28.387,0Z",
    transform: "translate(1351.259 391.148) rotate(30)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347-2743",
    "data-name": "Path 2347",
    d: "M1128.044,412.839H421.259a11.316,11.316,0,0,0,0,22.631h20.02v270.7a11.316,11.316,0,0,0,22.631,0l.172-270.7h619.571v270.7a11.315,11.315,0,1,0,22.631,0l3.292-270.7h18.469a11.316,11.316,0,0,0,0-22.631Z",
    transform: "translate(374.286 130.326)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348-2744",
    "data-name": "Path 2348",
    d: "M545.834,371.853v47.918H425.781a23.974,23.974,0,0,1-1.667-47.918q.833-.029,1.667,0Z",
    transform: "translate(372.223 120.892)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349-2745",
    "data-name": "Path 2349",
    d: "M549.266,419.607a1.844,1.844,0,0,1-1.843,1.843h-123.3a25.249,25.249,0,0,1,0-50.5h123.3a1.843,1.843,0,1,1,0,3.686h-123.3a21.563,21.563,0,0,0,0,43.126h123.3A1.844,1.844,0,0,1,549.266,419.607Z",
    transform: "translate(371.74 120.688)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350-2746",
    "data-name": "Path 2350",
    d: "M542.939,380.978H413.929a.369.369,0,0,1-.007-.737H542.939a.369.369,0,0,1,0,.737Z",
    transform: "translate(375.118 122.826)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351-2747",
    "data-name": "Path 2351",
    d: "M542.939,388.17H413.929a.369.369,0,1,1-.007-.737H542.939a.369.369,0,0,1,0,.737Z",
    transform: "translate(375.118 124.48)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352-2748",
    "data-name": "Path 2352",
    d: "M542.939,395.361H413.929a.369.369,0,0,1-.007-.737H542.939a.369.369,0,0,1,0,.737Z",
    transform: "translate(375.118 126.135)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353-2749",
    "data-name": "Path 2353",
    d: "M542.939,402.553H413.929a.369.369,0,1,1-.007-.737H542.939a.369.369,0,0,1,0,.737Z",
    transform: "translate(375.118 127.79)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354-2750",
    "data-name": "Path 2354",
    d: "M527.437,330.812V378.73H407.384a23.974,23.974,0,0,1-1.667-47.918q.833-.029,1.667,0Z",
    transform: "translate(367.989 111.449)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355-2751",
    "data-name": "Path 2355",
    d: "M530.868,378.566a1.844,1.844,0,0,1-1.843,1.843h-123.3a25.249,25.249,0,0,1,0-50.5h123.3a1.843,1.843,0,1,1,0,3.686h-123.3a21.563,21.563,0,0,0,0,43.126h123.3a1.844,1.844,0,0,1,1.843,1.843Z",
    transform: "translate(367.507 111.245)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356-2752",
    "data-name": "Path 2356",
    d: "M524.541,339.937H395.531a.369.369,0,1,1-.007-.737H524.541a.369.369,0,1,1,0,.737Z",
    transform: "translate(370.885 113.382)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357-2753",
    "data-name": "Path 2357",
    d: "M524.541,347.128H395.531a.369.369,0,1,1-.007-.737H524.541a.369.369,0,1,1,0,.737Z",
    transform: "translate(370.885 115.037)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358-2754",
    "data-name": "Path 2358",
    d: "M524.541,354.32H395.531a.369.369,0,1,1-.007-.737H524.541a.369.369,0,1,1,0,.737Z",
    transform: "translate(370.885 116.692)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359-2755",
    "data-name": "Path 2359",
    d: "M524.541,361.512H395.531a.369.369,0,1,1-.007-.737H524.541a.369.369,0,1,1,0,.737Z",
    transform: "translate(370.885 118.346)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360-2756",
    "data-name": "Path 2360",
    d: "M646.112,559.8v-41.78a6.964,6.964,0,0,0-6.963-6.963H480.731a6.964,6.964,0,0,0-6.963,6.963V559.8Z",
    transform: "translate(388.972 152.926)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 172.344,
    height: 53.966,
    transform: "translate(862.74 728.395)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361-2757",
    "data-name": "Path 2361",
    d: "M473.768,620.029v41.78a6.964,6.964,0,0,0,6.963,6.964H639.148a6.963,6.963,0,0,0,6.963-6.963V620.029Z",
    transform: "translate(388.972 178)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_427",
    "data-name": "Ellipse 427",
    cx: 5.223,
    cy: 5.223,
    r: 5.223,
    transform: "translate(942.819 684.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_428",
    "data-name": "Ellipse 428",
    cx: 5.223,
    cy: 5.223,
    r: 5.223,
    transform: "translate(942.819 754.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_429",
    "data-name": "Ellipse 429",
    cx: 5.223,
    cy: 5.223,
    r: 5.223,
    transform: "translate(943.099 822.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362-2758",
    "data-name": "Path 2362",
    d: "M625.086,472.333v47.918H505.033a23.974,23.974,0,1,1-1.669-47.918q.834-.029,1.669,0Z",
    transform: "translate(390.458 144.013)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363-2759",
    "data-name": "Path 2363",
    d: "M628.521,520.087a1.844,1.844,0,0,1-1.843,1.843H503.38a25.249,25.249,0,1,1-.03-50.5H626.678a1.843,1.843,0,1,1,0,3.686H503.38a21.563,21.563,0,1,0,0,43.126h123.3A1.844,1.844,0,0,1,628.521,520.087Z",
    transform: "translate(389.973 143.808)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364-2760",
    "data-name": "Path 2364",
    d: "M622.191,481.458H493.181a.369.369,0,1,1-.007-.737H622.191a.369.369,0,1,1,0,.737Z",
    transform: "translate(393.354 145.946)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365-2761",
    "data-name": "Path 2365",
    d: "M622.191,488.65H493.181a.369.369,0,1,1-.007-.737H622.191a.369.369,0,1,1,0,.737Z",
    transform: "translate(393.354 147.601)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366-2762",
    "data-name": "Path 2366",
    d: "M622.191,495.841H493.181a.369.369,0,1,1-.007-.737H622.191a.369.369,0,1,1,0,.737Z",
    transform: "translate(393.354 149.255)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367-2763",
    "data-name": "Path 2367",
    d: "M622.191,503.033H493.181a.369.369,0,1,1-.007-.737H622.191a.369.369,0,1,1,0,.737Z",
    transform: "translate(393.354 150.91)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368-2764",
    "data-name": "Path 2368",
    d: "M496.748,317.815h-54.7a3.379,3.379,0,0,0-1.5.348l-13.805,6.911a2.516,2.516,0,0,0,0,4.631l13.805,6.911a3.38,3.38,0,0,0,1.5.348h54.7a2.871,2.871,0,0,0,3.029-2.664V320.479A2.871,2.871,0,0,0,496.748,317.815Z",
    transform: "translate(377.801 108.46)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369-2765",
    "data-name": "Path 2369",
    d: "M488.435,320.479V334.3a2.871,2.871,0,0,1-3.029,2.664h-10.9V317.815h10.9A2.871,2.871,0,0,1,488.435,320.479Z",
    transform: "translate(389.143 108.46)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(930.839 361.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2370-2766",
    "data-name": "Path 2370",
    d: "M216.167,522.649a29.518,29.518,0,0,0,28.5-5.021c9.983-8.379,13.114-22.184,15.66-34.967l7.533-37.809-15.771,10.86c-11.342,7.81-22.939,15.869-30.792,27.181s-11.281,26.753-4.971,38.993",
    transform: "translate(-197.593 -444.852)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371-2767",
    "data-name": "Path 2371",
    d: "M217.9,577.9c-1.6-11.627-3.238-23.4-2.118-35.156.994-10.437,4.179-20.631,10.661-28.989a48.223,48.223,0,0,1,12.373-11.212c1.237-.781,2.376,1.18,1.144,1.957a45.845,45.845,0,0,0-18.134,21.88c-3.948,10.042-4.582,20.989-3.9,31.656.411,6.451,1.283,12.86,2.162,19.26a1.174,1.174,0,0,1-.792,1.394,1.14,1.14,0,0,1-1.394-.792Z",
    transform: "translate(-197.983 -454.326)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372-2768",
    "data-name": "Path 2372",
    d: "M236.8,563.524a21.729,21.729,0,0,0,18.932,9.771c9.584-.455,17.574-7.144,24.766-13.494l21.274-18.783-14.08-.674c-10.125-.484-20.512-.936-30.156,2.186S239,553.167,237.238,563.15",
    transform: "translate(-201.506 -460.527)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373-2769",
    "data-name": "Path 2373",
    d: "M212.964,593.88c7.683-13.595,16.595-28.7,32.519-33.533a36.288,36.288,0,0,1,13.678-1.412c1.452.125,1.09,2.364-.36,2.239a33.712,33.712,0,0,0-21.828,5.775c-6.155,4.189-10.947,10.013-15,16.19-2.484,3.783-4.71,7.727-6.936,11.665C214.324,596.062,212.245,595.153,212.964,593.88Z",
    transform: "translate(-197.554 -463.624)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374-2770",
    "data-name": "Path 2374",
    d: "M197.644,613.664a16.453,16.453,0,0,1,10.082-13.781v-7.859h13.182v8.107a16.444,16.444,0,0,1,9.533,13.533l3.1,36.031h-39Z",
    transform: "translate(-194.544 -469.098)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375-2771",
    "data-name": "Path 2375",
    d: "M748.56,417.825l-5.775-2.432-3.962-28.951H686.065l-4.294,28.833-5.167,2.583a1.227,1.227,0,0,0,.549,2.324h70.931a1.227,1.227,0,0,0,.476-2.358Z",
    transform: "translate(435.488 124.253)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376-2772",
    "data-name": "Path 2376",
    d: "M860.626,397.37H601.465a5.134,5.134,0,0,1-5.123-5.134V355.691H865.749v36.545a5.134,5.134,0,0,1-5.123,5.134Z",
    transform: "translate(417.176 117.177)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377-2773",
    "data-name": "Path 2377",
    d: "M866.064,400.14H596.15V243.771a6.2,6.2,0,0,1,6.19-6.189H859.874a6.2,6.2,0,0,1,6.19,6.189Z",
    transform: "translate(417.132 90)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378-2774",
    "data-name": "Path 2378",
    d: "M847.82,386.668H610.148a4.777,4.777,0,0,1-4.772-4.772V251.58a4.777,4.777,0,0,1,4.772-4.772H847.82a4.777,4.777,0,0,1,4.772,4.772V381.9a4.777,4.777,0,0,1-4.772,4.772Z",
    transform: "translate(419.255 92.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379-2775",
    "data-name": "Path 2379",
    d: "M752.456,398.6a14.289,14.289,0,0,1,21.731,2.8l32.148-5.716,8.238,18.689L769.061,421.8a14.366,14.366,0,0,1-16.6-23.2Z",
    transform: "translate(452.02 126.176)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380-2776",
    "data-name": "Path 2380",
    d: "M775.776,435.034l33.515-.418,4.242-.057,68.187-.859s18.517-17.665,34.641-35.853L914.1,381.5a66.783,66.783,0,0,0-22.392-41.349c-23.093,15.431-36.485,45.973-36.485,45.973l-42.279,10.112-4.23,1.011-26.27,6.278Z",
    transform: "translate(458.464 113.601)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381-2777",
    "data-name": "Path 2381",
    d: "M941.565,498.962h-62.56c0,2.681-68.386,4.856-68.386,4.856a24.981,24.981,0,0,0-4.1,3.885,24.107,24.107,0,0,0-5.634,15.539v3.885a24.289,24.289,0,0,0,24.28,24.28h116.4a24.3,24.3,0,0,0,24.28-24.28v-3.885A24.314,24.314,0,0,0,941.565,498.962Z",
    transform: "translate(464.242 150.143)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 25.252,
    height: 145.754,
    transform: "translate(1335.062 700.586)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382-2778",
    "data-name": "Path 2382",
    d: "M799.312,663.139c0,2.728,38.265,1.055,85.467,1.055s85.467,1.673,85.467-1.055-38.265-24.365-85.467-24.365S799.312,660.41,799.312,663.139Z",
    transform: "translate(463.879 182.314)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383-2779",
    "data-name": "Path 2383",
    d: "M680.374,421.021H661.58l-8.94-72.488h27.736Z",
    transform: "translate(565.854 407.778)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385-2780",
    "data-name": "Path 2385",
    d: "M635.219,421.021H616.425l-8.94-72.488h27.736Z",
    transform: "translate(555.464 407.778)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_430",
    "data-name": "Ellipse 430",
    cx: 32.676,
    cy: 32.676,
    r: 32.676,
    transform: "translate(1326.354 346.122)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387-2781",
    "data-name": "Path 2387",
    d: "M956.891,463.163s10.964,57.975-30.752,65.358S824.2,541.093,824.2,541.093L797.163,667.26l-36.33-3.244s4.832-151.877,16.714-163.759S864.53,452.8,864.53,452.8Z",
    transform: "translate(455.025 139.521)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388-2782",
    "data-name": "Path 2388",
    d: "M886.119,441.471l-18.245,18.3S736.138,480.994,731.056,511.42c-7.673,45.937-16.735,145.831-16.735,145.831l39.608-2.971L769.46,540.728l63.372-14.415,72.1-39.293Z",
    transform: "translate(444.323 136.915)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389-2783",
    "data-name": "Path 2389",
    d: "M915.328,267.765C912.1,261.679,908,249.55,901.493,247.3a51.758,51.758,0,0,0-11.143-2.374l-11.066,4.256,6.023-4.684q-1.759-.1-3.516-.171l-7.467,2.872,3.82-2.971c-6.961-.071-14.146.652-19.54,4.89-4.6,3.613-9.154,17.3-9.891,23.1a44.184,44.184,0,0,0,.812,16.644l1.891,1.8a23.207,23.207,0,0,0,1.484-4.722,22.364,22.364,0,0,1,10.705-14.523l.1-.058c3.171-1.785,7.02-1.7,10.656-1.572l17.273.622c4.156.15,8.63.413,11.87,3.019a19.546,19.546,0,0,1,4.746,6.875c1.61,3.249,4.756,15.5,4.756,15.5s1.78-2.313,2.633-.592a59.533,59.533,0,0,0,2.478-13.818A27.073,27.073,0,0,0,915.328,267.765Z",
    transform: "translate(475.146 91.528)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390-2784",
    "data-name": "Path 2390",
    d: "M1003.029,290.891A14.289,14.289,0,0,0,990.1,308.577L963.82,327.96,971.7,346.8l36.723-27.894a14.366,14.366,0,0,0-5.4-28.017Z",
    transform: "translate(501.732 102.258)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391-2785",
    "data-name": "Path 2391",
    d: "M1017.691,326.762l-65.873,73.159s-31.5-10.085-55.865-21.018l-10.945-33.616a66.847,66.847,0,0,1-3.2-24.189c33.774-8.987,73.057,24.453,73.057,24.453l49.309-38.624Z",
    transform: "translate(482.841 105.956)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392-2786",
    "data-name": "Path 2392",
    d: "M874.33,500.289c-11.752-4.06-23.9-8.257-37.013-9.833l-.563-.068.155-.545c13.569-47.643,10.182-78.119,3.533-123.9a46.241,46.241,0,0,1,26.507-48.59l.08-.036,37.437-2.379.085-.005,27.228,8.008a18.677,18.677,0,0,1,13.368,18.244c-.3,15.056.33,31.865.993,49.66,1.486,39.924,3.022,81.207-5.7,107.992l-.046.14-.116.091a44.4,44.4,0,0,1-28.392,9.973C899.669,509.042,887.2,504.734,874.33,500.289Z",
    transform: "translate(472.495 107.798)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393-2787",
    "data-name": "Path 2393",
    d: "M989.567,663.07H111.609c-.7,0-1.272-.779-1.272-1.741s.57-1.741,1.272-1.741H989.567c.7,0,1.272.779,1.272,1.741S990.27,663.07,989.567,663.07Z",
    transform: "translate(597.519 187.103)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94-2788",
    "data-name": "Path 94",
    d: "M907.854,678.591a55.9,55.9,0,0,0,5.1-6.231c2.959-4.1,5.585,16.912,5.585,16.912s2.848,8.545,2.136,12.817-17.089,4.272-19.937,3.56-17.089,0-17.089,0H862.283c-18.513-8.544,0-14.241,0-14.241,5.7-.712,24.922-18.513,24.922-18.513l4.272-7.832c2.848-.712,5.7,9.969,5.7,9.969Z",
    transform: "translate(277.878 141.014)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394-2789",
    "data-name": "Path 2394",
    d: "M907.854,678.591a55.9,55.9,0,0,0,5.1-6.231c2.959-4.1,5.585,16.912,5.585,16.912s2.848,8.545,2.136,12.817-17.089,4.272-19.937,3.56-17.089,0-17.089,0H862.283c-18.513-8.544,0-14.241,0-14.241,5.7-.712,24.922-18.513,24.922-18.513l4.272-7.832c2.848-.712,5.7,9.969,5.7,9.969Z",
    transform: "translate(333.164 141.014)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/hello.f1fcbbe50bae1a61a16dcf9bdb16b897.svg";
export { ForwardRef as ReactComponent };